/* eslint-disable react-hooks/exhaustive-deps */
import styled from "@emotion/styled";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProductDetail from "./ProductModule/ProductDetail";
import WeightMeasures from "./ProductModule/WeightMeasures";
import MEP from "./ProductModule/MEP";
import { Discontinues, PriceType, ProductStatus, ProductType, Units } from "../../../common/const";
import Resources from "./ProductModule/Resources";
import { useSelector } from "react-redux";
import { apiRequest } from "../../../common/common";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { LoadingPage } from "../../../common/LoadingPage";

const DividerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    minHeight: 50
}));

const DemoTabs = styled(Tabs)(({ theme }) => ({
    minWidth: 200,
    borderBottom: '2px solid #e8e8e8',
    [theme.breakpoints.down('xs')]: {
        marginLeft: '0%',
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '20px',
        fontSize: 10,
    },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
    minWidth: 110,
    fontSize: 14,
    fontFamily: 'open sans',
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
        minWidth: 8,
        fontSize: 10,
    },
    '&:hover': {
        backgroundColor: '#f6f7ff',
        color: 'black',
    },
}));


export default function CreateProduct() {
    const navigate = useNavigate();
    const { roles, user } = useSelector(state => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [errors, setErrors] = useState({});
    const [productId, setProductId] = useState(null);
    const [skuNo, setSkuNo] = useState(null);
    const [isDefault, setIsDefault] = useState(false);
    const [detailsData, setDetailsData] = useState({
        categoryid: null,
        categoryName: null,
        subCategoryid: null,
        productType: ProductType[0]?.value,
        modelName: null,
        manufacturerid: null,
        vendorid: null,
        catalog: null,
        is_customer_product: false,
        price: 0,
        priceType: PriceType[0]?.value,
        status: ProductStatus[0]?.value,
        leadtime: null,
        furnishResponsibility: null,
        installResponsibility: null,
        architecturalCode: null,
        lifeExpectancy: null,
        international: false,
        architecturallySignificant: false,
        spatiallySignificant: false,
        description: null,
        notes: null,
        isDiscontinued: Discontinues?.[1].value,
        converToCatalog: false
    });
    const [weightData, setWeightData] = useState({
        unit: Units[0]?.value,
        adjustableWidth: false,
        adjustableHeight: false,
        adjustableDepth: false,
        width: null,
        height: null,
        depth: null,
        mounting: null,
        weight: null,
        shipWeight: null,
        clearance: {
            left: null,
            right: null,
            front: null,
            back: null,
            top: null,
            bottom: null
        },
        ada: false,
        antiMicrobial: false,
        green: false,
        seismic: false,
        shielding: null,
        spatialRemarks: null,
    });
    const [mechanicalData, setMechanicalData] = useState({
        heatDissipation: null,
        dissipationType: null,
        vent: false,
        ventType: null,
        mechanicalRemarks: null
    });
    const [electricalData, setElectricalData] = useState({
        voltageType: null,
        volts: null,
        kva: null,
        remoteTrans: false,
        remoteSwitch: false,
        hertz: null,
        watts: null,
        amps: null,
        electricalPhase: null,
        plugtype: null,
        plugdetail: null,
        dedicatedCircuit: false,
        emergencyPower: false,
        electricalRemarks: null
    });
    const [plumbingData, setPlumbingData] = useState({
        hotWater: false,
        coldWater: false,
        treatedWater: false,
        steam: false,
        vaccumMedical: false,
        vaccumDental: false,
        drain: false,
        medicalGas: false,
        drainLocation: null,
        gasType: [],
        gasLocation: null,
        plumbingRemarks: null
    });
    const [technicalData, setTechnicalData] = useState({
        isConnection: false,
        connectionType: null,
        network: null,
        techRemarks: null
    });
    const [resources, setResource] = useState(null);
    const [rows, setRows] = useState([
        { extension: '--', type: 'Image', resource: '--', size: '--' },
        { extension: '--', type: 'Product Specification', resource: '--', size: '--' },
        { extension: '--', type: 'Product Brochure', resource: '--', size: '--' },
        { extension: '--', type: 'Product Planning', resource: '--', size: '--' },
        { extension: '--', type: 'Product Operating Manual', resource: '--', size: '--' },
        { extension: '--', type: 'URL', resource: '--', size: '--' },
        { extension: '--', type: '2D', resource: '--', size: '--' },
        { extension: '--', type: '3D', resource: '--', size: '--' },
        { extension: '--', type: 'Other Document', resource: '--', size: '--' },
    ]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                setDataLoading(true);
                try {
                    const response = await apiRequest('get', `/product/${id}`);
                    const { data } = response?.data;
                    setProductId(data?.product_id);
                    setDetailsData({
                        categoryid: data?.category_id,
                        categoryName: data?.category?.name,
                        subCategoryid: data?.sub_category_id,
                        productType: data?.type || ProductType[0]?.value,
                        modelName: data?.model,
                        manufacturerid: data?.manufacturer_id,
                        vendorid: data?.vendor_id,
                        catalog: data?.catalog,
                        currency: data?.currency,
                        price: data?.list_price,
                        priceType: data?.price_type || PriceType[0]?.value,
                        status: data?.status,
                        leadtime: data?.lead_time,
                        furnishResponsibility: data?.furnish_responsibility,
                        installResponsibility: data?.install_responsibility,
                        architecturalCode: data?.architectural_code,
                        lifeExpectancy: data?.life_expectancy,
                        international: data?.international,
                        architecturallySignificant: data?.architecturally_significant,
                        spatiallySignificant: data?.spatially_significant,
                        description: data?.description,
                        notes: data?.notes,
                        isDiscontinued: data?.discontinued,
                        is_customer_product: data?.is_customer_product
                    });
                    if (data?.numaric_sku === 0 && !data?.is_customer_product) {
                        setIsDefault(true);
                    }
                    setSkuNo(data?.numaric_sku);
                    setMechanicalData(data?.mechanical_data);
                    setElectricalData(data?.electrical_data);
                    setPlumbingData(data?.plumbing_data);
                    setTechnicalData(data?.tech_connection_data);
                    setWeightData({
                        unit: data?.units,
                        adjustableWidth: data?.adjustable_width,
                        adjustableHeight: data?.adjustable_height,
                        adjustableDepth: data?.adjustable_depth,
                        width: data?.width,
                        height: data?.height,
                        depth: data?.depth,
                        mounting: data?.mounting,
                        weight: data?.max_weight,
                        shipWeight: data?.ship_weight,
                        clearance: data?.clearance,
                        ada: data?.da_complient,
                        antiMicrobial: data?.antimicrobial,
                        green: data?.green,
                        seismic: data?.seismic,
                        shielding: data?.Shielding,
                        spatialRemarks: data?.spatial_remarks,
                    });
                    const getFileData = (key) => {
                        const file = data?.[key]?.[0];
                        if (!file) return {};

                        return {
                            resource: file?.fileName || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[0],
                            size: file.size ? `${(file.size / 1024).toFixed(2)} KB` : '--',
                            extension: file?.fileName?.split('.')?.pop() || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[1] || '--',
                            sortUrl: file?.sortUrl
                        };
                    };
                    setRows((prevData) =>
                        prevData.map((row) => {
                            if (row.type === 'Image') {
                                return { ...row, ...getFileData('images') };
                            }
                            if (row.type === 'Product Specification') {
                                return { ...row, ...getFileData('specifications_doc') };
                            }
                            if (row.type === 'Product Brochure') {
                                return { ...row, ...getFileData('brochure_doc') };
                            }
                            if (row.type === 'Product Planning') {
                                return { ...row, ...getFileData('site_planning_doc') };
                            }
                            if (row.type === 'Product Operating Manual') {
                                return { ...row, ...getFileData('operating_manual_doc') };
                            }
                            if (row.type === '2D') {
                                return { ...row, ...getFileData('twod_doc') };
                            }
                            if (row.type === '3D') {
                                return { ...row, ...getFileData('threed_doc') };
                            }
                            if (row.type === 'Other Document') {
                                return { ...row, ...getFileData('documents') };
                            }
                            if (row.type === 'URL') {
                                const resourceValue = data?.["website_url"]?.length === 0 ? '--' : data?.["website_url"].toString();
                                return {
                                    ...row,
                                    resource: resourceValue,
                                    extension: resourceValue !== '--' ? 'URL' : '--',
                                };
                            }
                            return row;
                        })
                    );
                    setDataLoading(false);
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        };
        fetchData();
    }, [id]);

    const handleBackClick = () => {
        if (activeTab >= 1) {
            setActiveTab(activeTab - 1);
        } else {
            navigate('/app/catalog');
        }
    };

    const handleNext = async () => {
        if (activeTab === 0) {
            const newErrors = {};
            if (!detailsData.categoryid) {
                newErrors.category = 'Please select category';
            }
            if (!detailsData.subCategoryid) {
                newErrors.subCategory = 'Please select subCategory';
            }
            if (detailsData.price < 0 && skuNo > 0 && !isDefault) {
                newErrors.price = 'Please enter a price';
            }
            if (!detailsData.modelName && (skuNo > 0 && !isDefault)) {
                newErrors.model = 'Please enter a model';
            }
            if (!detailsData.manufacturerid && (skuNo > 0 && !isDefault)) {
                newErrors.manufacturer = 'Please select manufacturer';
            }
            if (!skuNo) {
                newErrors.skuNo = 'Please enter a sku No';
            }

            setErrors(newErrors);
            if (Object.keys(newErrors).length === 0) {
                setDataLoading(true);
                const data = {
                    category_id: detailsData?.categoryid,
                    sub_category_id: detailsData?.subCategoryid,
                    description: detailsData?.description,
                    manufacturer_id: detailsData?.manufacturerid,
                    vendor_id: detailsData?.vendorid,
                    model: detailsData?.modelName,
                    catalog: detailsData?.catalog,
                    price_type: detailsData?.priceType,
                    list_price: Number(detailsData?.price),
                    currency: detailsData?.currency,
                    type: detailsData?.productType,
                    furnish_responsibility: detailsData?.furnishResponsibility,
                    install_responsibility: detailsData?.installResponsibility,
                    life_expectancy: detailsData?.lifeExpectancy,
                    lead_time: detailsData?.leadtime,
                    architectural_code: detailsData?.architecturalCode,
                    architecturally_significant: detailsData?.architecturallySignificant,
                    spatially_significant: detailsData?.spatiallySignificant,
                    status: detailsData?.status,
                    notes: detailsData?.notes,
                    international: detailsData?.international,
                    discontinued: detailsData?.isDiscontinued,
                    is_customer_product: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? false : true,
                    numaric_sku: isDefault ? 0 : ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product ? skuNo : ''
                };
                if (productId) {
                    try {
                        const response = await apiRequest('put', `/product/${productId}`, data);
                        if (response?.data) {
                            const { data } = response?.data;
                            showNotification(response?.data?.message, 'success');
                            setProductId(data?.product_id);
                            setActiveTab(activeTab + 1);
                            setDataLoading(false);
                        }
                    } catch (error) {
                        setDataLoading(false)
                        showNotification(error?.response?.data.error || error.message, 'error');
                    }
                } else {
                    try {
                        data.user_id = user?.user_id;
                        data.organization_id = user?.organization?.organization_id;
                        const response = await apiRequest('post', '/product', data);
                        if (response?.data) {
                            const { data } = response?.data;
                            showNotification(response?.data?.message, 'success');
                            setProductId(data?.product_id);
                            setActiveTab(activeTab + 1);
                            setDataLoading(false);
                        }
                    } catch (error) {
                        setDataLoading(false)
                        showNotification(error?.response?.data.error || error.message, 'error');
                    }
                }
            }
        } else if (activeTab === 1) {
            setDataLoading(true);
            const data = {
                product_id: productId,
                units: weightData?.unit,
                adjustable_width: weightData?.adjustableWidth,
                adjustable_height: weightData?.adjustableHeight,
                adjustable_depth: weightData?.adjustableDepth,
                width: weightData?.width?.toString(),
                height: weightData?.height?.toString(),
                depth: weightData?.depth?.toString(),
                clearance: weightData?.clearance,
                spatial_remarks: weightData?.spatialRemarks,
                max_weight: weightData?.weight?.toString(),
                ship_weight: weightData?.shipWeight?.toString(),
                mounting: weightData?.mounting,
                da_complient: weightData?.ada,
                antimicrobial: weightData?.antiMicrobial,
                green: weightData?.green,
                Shielding: weightData?.shielding,
                seismic: weightData?.seismic,
                model: detailsData?.modelName,
                type: detailsData?.productType,
                status: detailsData?.status,
                is_customer_product: detailsData?.is_customer_product,
                numaric_sku: isDefault ? 0 : ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product ? skuNo : ''
            }
            if (productId) {
                try {
                    const response = await apiRequest('put', `/product/${productId}`, data);
                    if (response?.data) {
                        showNotification(response?.data?.message, 'success');
                        setActiveTab(activeTab + 1);
                        setDataLoading(false);
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        } else if (activeTab === 2) {
            setDataLoading(true);
            const data = {
                product_id: productId,
                electrical_data: electricalData,
                mechanical_data: mechanicalData,
                plumbing_data: plumbingData,
                tech_connection_data: technicalData,
                model: detailsData?.modelName,
                type: detailsData?.productType,
                status: detailsData?.status,
                is_customer_product: detailsData?.is_customer_product,
                numaric_sku: isDefault ? 0 : ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product ? skuNo : ''
            }
            if (productId) {
                try {
                    const response = await apiRequest('put', `/product/${productId}`, data);
                    if (response?.data) {
                        showNotification(response?.data?.message, 'success');
                        setActiveTab(activeTab + 1);
                        setDataLoading(false);
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        }
    }


    const appendResource = (formData, resource, key, nullKeySuffix = '') => {
        if (resource) {
            formData.append(key, Array.isArray(resource) ? resource?.map(item => ({
                ...item,
                sortUrl: item?.sortUrl?.split('&at=')[0]
            })) : resource);
        } else if (resource === null) {
            if (key === 'product_doc') {
                formData.append(`documents${nullKeySuffix}`, Array.isArray(resource) ? resource.map(item => ({
                    ...item,
                    sortUrl: item?.sortUrl?.split('&at=')[0]
                })) : resource);
            } else if (key === 'product_images') {
                formData.append(`images${nullKeySuffix}`, Array.isArray(resource) ? resource.map(item => ({
                    ...item,
                    sortUrl: item?.sortUrl?.split('&at=')[0]
                })) : resource);
            } else {
                formData.append(`${key}${nullKeySuffix}`, Array.isArray(resource) ? resource.map(item => ({
                    ...item,
                    sortUrl: item?.sortUrl?.split('&at=')[0]
                })) : resource);
            }
        }
    };

    const handleSubmit = async () => {
        setDataLoading(true);
        const formData = new FormData();
        appendResource(formData, resources?.otherdocument, 'product_doc', '_urls');
        appendResource(formData, resources?.["2d"], 'twod_doc', '_urls');
        appendResource(formData, resources?.["3d"], 'threed_doc', '_urls');
        appendResource(formData, resources?.productoperatingmanual, 'operating_manual_doc', '_urls');
        appendResource(formData, resources?.productplanning, 'site_planning_doc', '_urls');
        appendResource(formData, resources?.productbrochure, 'brochure_doc', '_urls');
        appendResource(formData, resources?.productspecification, 'specifications_doc', '_urls');
        appendResource(formData, resources?.image, 'product_images', '_urls');
        if (resources?.url) {
            formData.append('website_url', JSON.stringify(resources?.url?.split(',')));
        } else if (resources?.url === '') {
            formData.append('website_url', JSON.stringify([]));
        }
        formData.append('model', detailsData?.modelName);
        formData.append('type', detailsData?.productType);
        formData.append('category_id', detailsData?.categoryid);
        formData.append('sub_category_id', detailsData?.subCategoryid);
        formData.append('numaric_sku', isDefault ? 0 : (['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product) || detailsData?.converToCatalog ? skuNo : '');
        formData.append('status', detailsData?.status);
        if (detailsData.is_customer_product) {
            formData.append('is_customer_product', ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && detailsData?.converToCatalog ? false : true);
        } else {
            formData.append('is_customer_product', ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? false : true);
        }
        try {
            if (productId) {
                const response = await apiRequest('put', `/product/${productId}`, formData);
                if (response?.data) {
                    showNotification(response?.data?.message, 'success');
                    setDataLoading(false);
                    navigate('/app/catalog');
                }
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DividerHeader />
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <DemoTabs
                        value={activeTab}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tooltip title={activeTab >= 1 ? 'Previous tab' : 'Back to Product'}>
                            <IconButton onClick={handleBackClick} color="primary" style={{ height: 'fit-content', alignSelf: 'center', }}>
                                <ArrowBackIosIcon color="#005eb2" />
                            </IconButton>
                        </Tooltip>
                        <DemoTab label="Details" value={0} />
                        <DemoTab label="Physical" value={1} />
                        <DemoTab label="Utility" value={2} />
                        <DemoTab label="Resources" value={3} />
                        {activeTab < 3
                            ? (
                                <>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            handleNext();
                                        }}
                                        style={{
                                            marginLeft: 'auto',
                                            marginRight: 5,
                                            height: 'fit-content',
                                            alignSelf: 'center',
                                        }}
                                        size="small"
                                        color="primary"
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            if (productId) {
                                                setActiveTab(activeTab + 1);
                                            } else {
                                                handleNext();
                                            }
                                        }}
                                        style={{
                                            alignSelf: 'center',
                                        }}
                                        size="small"
                                        color="primary"
                                    >
                                        Next
                                    </Button>
                                </>
                            )
                            : (
                                <>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                        style={{
                                            marginLeft: 'auto',
                                            marginRight: 5,
                                            height: 'fit-content',
                                            alignSelf: 'center',
                                        }}
                                        size="small"
                                        color="primary"
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={async () => {
                                            setDataLoading(true);
                                            const formData = new FormData();
                                            formData.append('model', detailsData?.modelName);
                                            formData.append('type', detailsData?.productType);
                                            formData.append('category_id', detailsData?.categoryid);
                                            formData.append('sub_category_id', detailsData?.subCategoryid);
                                            formData.append('numaric_sku', isDefault ? 0 : (['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product) || detailsData?.converToCatalog ? skuNo : '');
                                            formData.append('status', detailsData?.status);
                                            if (detailsData.is_customer_product) {
                                                formData.append('is_customer_product', ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && detailsData?.converToCatalog ? false : true);
                                            } else {
                                                formData.append('is_customer_product', ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? false : true);
                                            }
                                            try {
                                                if (productId) {
                                                    const response = await apiRequest('put', `/product/${productId}`, formData);
                                                    if (response?.data) {
                                                        setDataLoading(false);
                                                        navigate('/app/catalog');
                                                    }
                                                }
                                            } catch (error) {
                                                setDataLoading(false);
                                                showNotification(error?.response?.data.error || error.message, 'error');
                                            }
                                        }}
                                        style={{
                                            alignSelf: 'center',
                                        }}
                                        size="small"
                                        color="primary"
                                    >
                                        Cancel
                                    </Button>
                                </>)}
                    </DemoTabs>
                </Box>
                {activeTab === 0 && (
                    <ProductDetail
                        detailsData={detailsData}
                        setDetailsData={setDetailsData}
                        errors={errors}
                        setErrors={setErrors}
                        setSkuNo={setSkuNo}
                        skuNo={skuNo}
                        isDefault={isDefault}
                        setIsDefault={setIsDefault}
                        setDataLoading={setDataLoading}
                    />
                )}
                {activeTab === 1 && (
                    <WeightMeasures
                        weightData={weightData}
                        setWeightData={setWeightData}
                    />
                )}
                {activeTab === 2 && (
                    <MEP
                        electricalData={electricalData}
                        setElectricalData={setElectricalData}
                        mechanicalData={mechanicalData}
                        setMechanicalData={setMechanicalData}
                        plumbingData={plumbingData}
                        setPlumbingData={setPlumbingData}
                        technicalData={technicalData}
                        setTechnicalData={setTechnicalData}
                    />
                )}
                {activeTab === 3 && (
                    <Resources
                        setResource={setResource}
                        rows={rows}
                        setRows={setRows}
                        detailsData={detailsData}
                        setDetailsData={setDetailsData}
                        setSkuNo={setSkuNo}
                    />
                )}
            </Box>
        </Box>
    )
}